export const merge = (target, ...args) => {
    for (let idx = 0, jdx = args.length; idx < jdx; idx += 1) {
        const source = args[idx] || {};
        for (const prop in source) {
            if (Object.prototype.hasOwnProperty.call(source, prop)) {
                const value = source[prop];
                if (value !== undefined) {
                    target[prop] = value;
                }
            }
        }
    }
    return target;
};
